<template>
    <div
        :id="id"
        class="lni-c-warehouse-retaliation"
    >
        <lni-spinner
            v-if="load"
            :id="`${id}_spinner`"
            :inline="false"
        />
        <div
            class="lni-c-warehouse-retaliation"
        >
            <div
                class="lni-c-box--content lni-u-mhauto lni-u-mv3"
            >
                <h1 class="lni-u-heading--1">
                    {{ getData('confirmation.heading') }}
                </h1>
                <h2 class="lni-u-heading--2 lni-u-mt3 lni-u-mb2">
                    {{ getData('confirmation.lead') }}
                </h2>
                <button
                    class="lni-u-button-reset lni-u-link-style"
                    href="#"
                    @click="print"
                >
                    <span
                        class="lnicon--print lni-u-mr1"
                        aria-hidden="true"
                    />
                    <span>{{ getData('confirmation.pdf') }} </span>
                </button>
                <div class="lni-u-mt2">
                    <span class="lni-u-heading--5 lni-u-text--all-caps">
                        Complaint Number: {{ complaintNumber }}
                    </span>
                    <p>
                        {{ getData('confirmation.helper') }}
                    </p>
                </div>
                <div class="lni-u-mt3 lni-u-pt3 lni-u-bt lni-u-b--subtle">
                    <span class="lni-u-type--bold">{{ getData('confirmation.minWage') }}</span>
                    <div class="lni-u-pl3">
                        <ul>
                            <li
                                v-for="complaint in complaints"
                                :key="complaint"
                            >
                                {{ translateComplaint(complaint) }}
                            </li>
                        </ul>
                    </div>
                    <div
                        v-if="complaintDetails.otherComplaint"
                        class="lni-u-pl4"
                    >
                        <span class="lni-u-type--bold lni-u-pr2">Description: </span>
                        {{ complaintDetails.otherComplaint }}
                    </div>
                    <div class="lni-u-mt2">
                        <span
                            class="lni-u-heading--5 lni-u-text--all-caps retaliation-complaint"
                        >
                            {{ getData('complaint.describe.label') }}
                        </span>
                        <p>
                            <span> {{ complaintDetails.complaintDescribe }} </span>
                        </p>
                    </div>
                    <div
                        v-show="complaintDetails.complaintDescription"
                        class="lni-u-mt2"
                    >
                        <span
                            class="lni-u-heading--5 lni-u-text--all-caps retaliation-complaint"
                        >
                            {{ getData('confirmation.circumstances') }}
                        </span>
                        <p>
                            <span> {{ complaintDetails.complaintDescription }} </span>
                        </p>
                    </div>
                    <div
                        v-show="complaintDetails.outcomeDescription"
                        class="lni-u-mt2"
                    >
                        <span
                            class="lni-u-heading--5 lni-u-text--all-caps retaliation-complaint"
                        >
                            {{ getData('complaint.outcome.label') }}
                        </span>
                        <p>
                            <span> {{ complaintDetails.outcomeDescription }} </span>
                        </p>
                    </div>
                    <div class="lni-u-pt2 lni-u-bb lni-u-mb1 lni-u-pb2 lni-u-b--subtle">
                        <div v-show="complaintDetails.userFiledComplaint === 'YES'">
                            <div class="lni-u-full-width lni-u-text--left lni-u-mt1">
                                <span
                                    class="lni-u-heading--5 lni-u-type--bold lni-u-text--all-caps retaliation-complaint"
                                >{{ getData('confirmation.reported') }}</span>

                                <p>
                                    {{ getText(complaintDetails.agencyDetails) }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="lni-u-mt2">
                    <h3 class="lni-u-heading--3">
                        {{ userInput.contact.heading }}
                    </h3>
                    <div class="lni-u-mt1">
                        <p>
                            Name: {{ userInput.contact.firstName }}
                            {{ userInput.contact.lastName }}
                        </p>
                        <p>
                            Preferred Language:
                            {{ translate(userInput.contact.userLanguage) }}
                        </p>
                        <p>Phone: {{ userInput.contact.phoneNumber }}</p>
                        <p>Email: {{ userInput.contact.emailAddress }}</p>
                    </div>

                    <div class="lni-u-pl2 lni-u-mt1">
                        <p>{{ userInput.contact.address1 }}</p>
                        <p v-if="userInput.contact.address2">
                            {{ userInput.contact.address2 }}
                        </p>
                        <p>
                            <span
                                v-if="userInput.contact.city"
                                v-show="getText(userInput.contact.city)"
                            >
                                {{ userInput.contact.city }},
                            </span>
                            <span
                                v-if="userInput.contact.state"
                                v-show="getText(userInput.contact.state)"
                            >
                                {{ userInput.contact.state }}
                            </span>
                            <span
                                v-if="userInput.contact.zip"
                                v-show="getText(userInput.contact.zip)"
                            >
                                {{ userInput.contact.zip }}
                            </span>
                        </p>
                    </div>
                </div>
                <div class="lni-u-mt2">
                    <h3 class="lni-u-heading--3">
                        {{ userInput.employer.heading }}
                    </h3>
                    <div class="lni-u-mt1">
                        <p v-show="getText(userInput.employer.dba)">
                            Company Name: {{ userInput.employer.dba }}
                        </p>
                        <p v-show="getText(userInput.employer.primaryPhone)">
                            Phone: {{ userInput.employer.primaryPhone }}
                        </p>
                        <p v-show="getText(userInput.employer.primaryEmail)">
                            Email: {{ userInput.employer.primaryEmail }}
                        </p>
                        <div class="lni-u-pl2">
                            <p v-show="getText(userInput.employer.street1)">
                                {{ userInput.employer.street1 }}
                            </p>
                            <p v-if="userInput.employer.street2">
                                {{ userInput.employer.street2 }}
                            </p>
                            <p>
                                <span
                                    v-if="userInput.employer.city"
                                    v-show="getText(userInput.employer.city)"
                                >
                                    {{ userInput.employer.city }},
                                </span>
                                <span
                                    v-if="userInput.employer.state"
                                    v-show="getText(userInput.employer.state)"
                                >
                                    {{ userInput.employer.state }}
                                </span>
                                <span
                                    v-if="userInput.employer.zip"
                                    v-show="getText(userInput.employer.zip)"
                                >
                                    {{ userInput.employer.zip }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="lni-u-mv2">
                    <h3 class="lni-u-heading--3 lni-u-pb2">
                        {{ getData('confirmation.files.heading') }}
                    </h3>
                    <div v-show="files.length === 0">
                        None
                    </div>
                    <lni-file-uploads
                        :id="`confirmation_file-uploads`"
                        :allowDelete="false"
                        :uploadedFiles="files"
                    />
                </div>
                <div class="lni-u-mv2 lni-u-pv2 lni-u-bt lni-u-ml1 lni-u-b--subtle print-hide">
                    <lni-html-element
                        id="confirmation_what-happens-next"
                        :htmlString="getData('whatHappensNext')"
                    />
                </div>
                <div class="lni-u-flex lni-u-bt lni-u-bb lni-u-pb1 lni-u-flex-row">
                    <div class="lni-u-pt3 lni-u-pb2 lni-u-ml1 lni-u-br lni-u-full-width lni-u-b--subtle print-hide">
                        <lni-html-element
                            id="confirmation_contact"
                            :htmlString="getData('contact')"
                        />
                    </div>
                    <div class="lni-u-pt1 lni-u-ml2 lni-u-ph1 lni-u-full-width lni-u-pt3 print-hide">
                        <lni-html-element
                            id="confirmation_what-next"
                            :htmlString="getData('next')"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "LniRetaliationConfirmation",
    computed: {
        data() {
            return this.$store.getters['appState/data'];
        },
        complaintNumber() {
            return this.$store.getters["appState/complaintNumber"];
        },
        confirmation() {
            return this.$store.getters["appState/confirmation"]
        },
        userInput() {
            return this.$store.getters["appState/formData"];
        },
        complaintDetails() {
            return this.$store.getters["appState/complaint"]
        },
        complaints() {
            return this.$store.getters["appState/complaints"];
        },
        files() {
            return this.$store.getters["appState/documents"];
        },
    },
    async mounted() {
        const payload = {
            oneLni: this.$oneLni,
            sourceId: 'confirm',
        };
        await this.$store.dispatch(`${this.id}/initialize`, payload);
    },
    methods: {
        getData(name) {
            return this.$store.getters['appState/data'] ? this.$store.getters['appState/data'](name) : '';
        },
        translateComplaint(complaint) {
            let data = this.$store.getters['appState/data'] ? this.$store.getters['appState/data'](name) : '';
            return data['complaint.options'].filter(
                (opt) => opt.value === complaint
            )[0].text
        },
        getText(value) {
            return value && value.length ? value : this.placeholder;
        },
        getYesNoText(value) {
            return value
                ? this.$store.state.appState.yesNoOptions.find(
                    (opt) => opt.value === value
                ).text
                : this.placeholder;
        },
        print() {
            window.print();
        },
        translate(language) {
            let data = this.$store.getters['appState/data'] ? this.$store.getters['appState/data'](name) : '';
            return data['contact.preferredLanguage.options'].find(
                (x) => x.value == language
            ).text;
        },
    },
};
</script>
